import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const authService = inject(AuthService);

  if (authService.accessToken) {
    const setHeaders: Record<string, string> = {
      Authorization: `Bearer ${authService.accessToken}`,
    };

    if (authService.activePermission) {
      setHeaders['Impersonate-User-Id'] = authService.activePermission.requester_user_id;
    }

    const clonedRequest = req.clone({
      setHeaders,
    });

    return next(clonedRequest);
  }

  return next(req);
};
